import { FC } from 'react'
import { GetServerSideProps } from 'next'

import SpecialitySearch from 'components/search/speciality-search/speciality-search'

import restRequest from 'utils/server-side/restRequest'
import { formatSpecialities } from 'store/lists/useSpecialities'
import { IOptions } from 'constants/types/common.types'
import { normalizeData, CARDS_ON_PAGE } from 'components/search/speciality-search/utils'

interface ISpecialityWebinar {
  data: string
}
const WebinarSpeciality: FC<ISpecialityWebinar> = (props) => {
  return <SpecialitySearch data={props.data}></SpecialitySearch>
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const props = {
    specialities: [] as IOptions[],
    initCards: [] as any,
    searchData: {} as ReturnType<typeof normalizeData>,
  }

  try {
    const recievedSpecialities = await restRequest(context, 'get', '/api/speciality', {
      limit: 1000,
    })

    if (recievedSpecialities.status !== 200) throw new Error('rest request error')
    const offset = context.query.page
      ? CARDS_ON_PAGE * Number(context.query.page) - CARDS_ON_PAGE
      : 0
    const formatedSpecialities = formatSpecialities(recievedSpecialities.data)
    props.specialities = formatedSpecialities
    const data = normalizeData(context.resolvedUrl, context.query, formatedSpecialities, 0)

    const recievedCards = await restRequest(context, 'get', '/api/search', {
      s: data.searchString,
      sort: data.selectedSort[0],
      offset: offset,
    })
    props.initCards = recievedCards.data
    props.searchData = data
  } catch (err) {
    console.log(err)
  }

  return {
    props: {
      data: JSON.stringify(props),
    },
  }
}

export default WebinarSpeciality
